import React from 'react';

import { PortalConfigContext, RouteContext } from 'src/context';
import { getClientSettingsTerm } from 'src/utils/clientSettingsPaths';

import { findSettingsPageByPath } from './settingsRegistry';

/** The registry entry for the current URL; undefined on sub-pages and pages outside the registry. */
export const useCurrentSettingsPage = () => {
  const { pathname } = React.useContext(RouteContext);
  const { features } = React.useContext(PortalConfigContext);
  return findSettingsPageByPath(
    pathname,
    getClientSettingsTerm(features.customLabels),
  );
};
